import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Alert, Button } from 'reactstrap';
import LessonItem from '../_lesson';
import { loadLessonResults, completeLesson } from '../../../utils/Api';
import { toLocalTime, getTextFromHtml } from '../../../utils/helper';
import { isLocal, domain } from '../../../config';

const path = isLocal ? '//localhost:3002/#' : `${domain}/company/#`;

const mapStateToProps = ({ user }) => ({
  permissions: user.permissions || [],
  allow_chat: user.options && user.options.allow_chat,
  hide_links_on_learning: user.options && user.options.hide_links_on_learning,
  all_in_one_tab: user.options && user.options.all_in_one_tab,
});
class Results extends React.Component {
  constructor(props) {
    super(props);

    this.id = +props.match.params.id;

    this.onContinue = this.onContinue.bind(this);

    this.state = {
      errorMessage: '',
    };
  }

  componentDidMount() {
    loadLessonResults(this.id).then((r) => {
      this.setState(r.error && r.error.msg ? { errorMessage: r.error.msg } : r);
    });
  }

  onContinue(e) {
    completeLesson(this.id).then((r) => {
      this.setState(r.error && r.error.msg ? { errorMessage: r.error.msg } : r);
    });
  }

  render() {

    const { permissions, allow_chat, hide_links_on_learning, all_in_one_tab } = this.props;
    if (!permissions.includes('LESSON_STATISTICS')) {
      return null;
    }

    const {
      correct_count,
      incorrect_count,
      lesson_started_time,
      lesson_finished_time,
      lesson_title,
      lesson_type,
      questions_count,
      trainer_firstname,
      trainer_lastname,
      training_title,
      training_id,
      retries_count,
      retries_max,
      passing_mandatory,
      status,
      errorMessage,
      passing,
      allow_continue,
    } = this.state;

    return (
      <React.Fragment>
        {!hide_links_on_learning &&
          <div className="category_block">
            <ul>
              {allow_chat && (
                <li className="category">
                  <Link to="/trainings/chats" target={all_in_one_tab ? "_self" : "_blank"}>
                    <i className="icon_c icon_c_bg icon_chats" />
                    <FormattedMessage id="routes_chats" />
                  </Link>
                </li>
              )}
              <li className="category">
                <a href={`${path}/reports/users`} target={all_in_one_tab ? "_self" : "_blank"} rel="noreferrer">
                  <i className="icon_c icon_c_bg icon_reports" />
                  <FormattedMessage id="routes_reports" />
                </a>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/notes`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_notes" />
                  <FormattedMessage id="routes_notes" />
                </Link>
              </li>
              <li className="category">
                <Link to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/pictures`} target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_images" />
                  <FormattedMessage id="routes_pictures" />
                </Link>
              </li>
              <li className="category">
                <Link to="/trainings/certificates" target={all_in_one_tab ? "_self" : "_blank"}>
                  <i className="icon_c icon_c_bg icon_cert" />
                  <FormattedMessage id="routes_certificates" />
                </Link>
              </li>
            </ul>
          </div>
        }
        <div className="main_content">
          <section>
            <div className="content">
              {errorMessage ? (
                <Alert color="danger">{errorMessage}</Alert>
              ) : (
                <div className="tiles">
                  <LessonItem
                    item={{
                      correct_count,
                      incorrect_count,
                      questions_count,
                      id: this.id,
                      training_id,
                      title: lesson_title,
                      retries_count,
                      retries_max,
                      type: lesson_type,
                      status,
                      passing_mandatory
                    }}
                  />
                  <div
                    className="ml-4 ml-mobile"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <div>
                      <FormattedMessage
                        id="lessons_results_training"
                        values={{ text: getTextFromHtml(training_title) }}
                      />
                    </div>
                    <div>
                      <FormattedMessage
                        id="lessons_results_trainer"
                        values={{
                          firstname: trainer_firstname,
                          lastname: trainer_lastname,
                        }}
                      />
                    </div>
                    <div>
                      <FormattedMessage
                        id="lessons_results_startDate"
                        values={{ text: toLocalTime(lesson_started_time) }}
                      />
                    </div>
                    <div>
                      <FormattedMessage
                        id="lessons_results_endDate"
                        values={{ text: toLocalTime(lesson_finished_time) }}
                      />
                    </div>
                    <div>
                      <FormattedMessage
                        id="lessons_results_totalQuestions"
                        values={{ count: questions_count }}
                      />
                    </div>
                    {lesson_type !== 'Poll' && (
                      <React.Fragment>
                        <div>
                          <FormattedMessage
                            id="lessons_results_correctAnswers"
                            values={{ count: correct_count }}
                          />
                        </div>
                        <div>
                          <FormattedMessage
                            id="lessons_results_incorrectAnswers"
                            values={{ count: incorrect_count }}
                          />
                        </div>
                      </React.Fragment>
                    )}
                    {(questions_count &&
                      100 * (correct_count / questions_count) >= passing) ||
                      (!questions_count && !correct_count && !incorrect_count) ? (
                      <Alert color="success">
                        <FormattedMessage id="lessons_results_youPassed" />
                      </Alert>
                    ) : (
                      <Alert color="danger">
                        <FormattedMessage id="lessons_results_youFailed" />
                      </Alert>
                    )}
                    {retries_count < retries_max ? (
                      <Link
                        className="mt-2"
                        to={`/trainings/mytrainings/${training_id}/lessons/${this.id}/passing`}
                      >
                        <Button>
                          <FormattedMessage id="overall_input_retry" />
                        </Button>
                      </Link>
                    ) : (
                      <Alert color="success">
                        <FormattedMessage id="lessons_results_youCompleted" />
                      </Alert>
                    )}
                    <Link
                      className="mt-2"
                      to={`/trainings/mytrainings/${training_id}/lessons`}
                    >
                      {allow_continue &&
                        (<Button onClick={this.onContinue}>
                          <FormattedMessage id="overall_input_continue" />
                        </Button>)}
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  match: PropTypes.objectOf(PropTypes.any),
  allow_chat: PropTypes.bool,
};

export default connect(mapStateToProps)(Results);



// WEBPACK FOOTER //
// ./src/views/_Lessons/Results/index.js